import RouteContent from './RouteContent';

export default RouteContent;



// WEBPACK FOOTER //
// ./src/components/RouteContent/index.js